import "@/utils/extensions/libs/ArrayExtension";
import { CatalogChooser } from "@/components/excel/schema/value/catalog";
import {
  IModeChooser,
  IModeOption,
} from "@/components/excel/schema/definiens/mode";
import {
  ITypeChooser,
  ITypeOption,
} from "@/components/excel/schema/definiens/bizType";
import { ICatalogOption } from "@/components/excel/schema/definiens/catalog";

const includeType = (chooser: ITypeChooser, type: number): boolean => {
  const { options } = chooser;
  if (!options.length) {
    return false;
  }
  return options.some((it) => it.value === type);
};
const findType = (
  chooser: ITypeChooser,
  type: number
): ITypeOption | undefined => {
  const { options } = chooser;
  if (!options.length) {
    return undefined;
  }
  return options.find((it) => it.value === type);
};
export const findCatalog = (
  type?: number | null
): ICatalogOption | undefined => {
  if (type === undefined || type === null) {
    return undefined;
  }
  const { options } = CatalogChooser;
  if (!options.length) {
    return undefined;
  }
  return options.find((it) => {
    if (it.type === null || it.type === undefined) {
      return false;
    }
    return includeType(it.type, type);
  });
};
export const findTypeOption = (
  type?: number | null
): ITypeOption | undefined => {
  if (type === undefined || type === null) {
    return undefined;
  }
  const { options } = CatalogChooser;
  if (!options.length) {
    return undefined;
  }
  return options.first(
    (it) => {
      if (it.type === null || it.type === undefined) {
        return undefined;
      }
      return findType(it.type, type);
    },
    (it) => it !== undefined
  );
};
export const findTypeText = (type?: number | null): string | undefined => {
  const typeOption = findTypeOption(type);
  return typeOption?.text;
};
export const findDefaultMode = (type?: number | null): number | undefined => {
  const typeOption = findTypeOption(type);
  return typeOption?.mode?.default;
};
export const findModes = (type?: number | null): IModeOption[] => {
  const typeOption = findTypeOption(type);
  return typeOption?.mode?.options ?? [];
};
export const findModeChooser = (type?: number | null): IModeChooser => {
  const typeOption = findTypeOption(type);
  return typeOption?.mode ?? { options: [] };
};
export const maybeChild = (type?: number | null): boolean => {
  const option = findTypeOption(type);
  if (option === undefined || option === null) {
    return false;
  }
  return option.parent !== undefined && option.parent !== null;
};
export function findParent(type?: number | null): number | undefined {
  const option = findTypeOption(type);
  if (option === undefined || option === null) {
    return undefined;
  }
  return option.parent?.value;
}
